export default __webpack_public_path__ + "static/media/image-add.1c9ce335.svg";